import React from 'react'
import { useSearchParams } from 'react-router'
import { getBetLoopSharedBetByPostId } from '@core/Areas/BetLoop/helpers/api'
import type { TabContentOptions } from '@core/Areas/BetLoop/Components/ProfileDisplay/types'
import {
  IncomingBetOpenPostIdSearchParam,
  IncomingBetViewPostIdSearchParam,
} from '@core/Areas/BetLoop/Components/ProfileDisplay/constants'
import type { IncomingBetLoopShare } from '../types'

export const useIncomingSharedBet = ({
  currentContentDisplay,
  handleIncomingShareTabChange,
}: {
  currentContentDisplay: TabContentOptions
  handleIncomingShareTabChange: (newValue: TabContentOptions) => void
}) => {
  const [incomingShare, setIncomingShare] = React.useState<IncomingBetLoopShare | null>(null)

  const [searchParams] = useSearchParams()
  const incomingPostId = searchParams.get(IncomingBetOpenPostIdSearchParam)
  const incomingViewPostId = searchParams.get(IncomingBetViewPostIdSearchParam)

  const handleIncomingShare = React.useCallback(
    ({ postId, isViewOnly }: { postId: string; isViewOnly: boolean }) => {
      getBetLoopSharedBetByPostId(Number(postId)).then(sharedBet => {
        const betOptionTab: TabContentOptions = sharedBet.isResulted
          ? 'resulted-bets'
          : 'pending-bets'
        const incomingShare: IncomingBetLoopShare = { sharedBet, isViewOnly, betOptionTab }

        handleIncomingShareTabChange(betOptionTab)
        setIncomingShare(incomingShare)
      })
    },
    [handleIncomingShareTabChange]
  )

  // ===========================
  // Reset on bet options change
  // ===========================
  React.useEffect(() => {
    if (incomingShare && incomingShare.betOptionTab !== currentContentDisplay) {
      setIncomingShare(null)
    }
  }, [currentContentDisplay, incomingShare])

  // ======================
  // Capture incoming share
  // ======================
  React.useEffect(() => {
    if (incomingPostId || incomingViewPostId) {
      const postId = (incomingPostId || incomingViewPostId) as string
      handleIncomingShare({ postId, isViewOnly: !!incomingViewPostId })
    }
  }, [incomingPostId, incomingViewPostId, handleIncomingShare])

  return incomingShare
}
